import React from "react";
import { Select,Tooltip } from "antd";

import { getOptionStyle, TooltipOverlayInnerStyle } from "../StyleObj";
import { useTheme } from "../components/ThemeContext";

const { Option } = Select;

const PlantSelection = ({ plantData, selectedPlant, handlePlantId }) => {

  const { theme } = useTheme();
  const handleChange = (value) => {
    handlePlantId(value)
  };
  return (
    <Select data-theme={theme}
      value={selectedPlant}
      style={{
        width: 200,
        marginLeft: "30px",
        marginRight: "30px",
      }}
      defaultValue={selectedPlant}
      className={`viewButtonStyle-${theme}`}
      onChange={handleChange}
    >
      {plantData?.map((m, index) => (
        <Option key={m?.PlantId ? m.PlantId : index} value={m.PlantId} style={getOptionStyle(theme)}>
          <Tooltip
            placement="top"
            title={m.PlantName}
            overlayClassName={theme === "dark" ? "custom-tooltip-dark" : "custom-tooltip-light"}
            overlayInnerStyle={{
              ...TooltipOverlayInnerStyle(theme)
            }}
          >
            {m.PlantName}
          </Tooltip>
        </Option>
      ))}
    </Select>
  );
};
export default PlantSelection;
